@if (loadingService.isLoading()) {
  <div class="fixed inset-0 flex items-center justify-center backdrop-blur-xs z-9999">
    <div class="flex flex-col items-center gap-4">
      <div class="flex gap-1.5">
        <div
          class="w-4.5 h-4.5 bg-blue-600 rounded-full animate-bounce [animation-delay:-0.3s]"
        ></div>
        <div
          class="w-4.5 h-4.5 bg-blue-600 rounded-full animate-bounce [animation-delay:-0.15s]"
        ></div>
        <div class="w-4.5 h-4.5 bg-blue-600 rounded-full animate-bounce"></div>
      </div>
    </div>
  </div>
}
